<template>
    <div class="body">
        <div class="filter">
            <el-row :gutter="20" class="mb20">
                <el-col :span="6">
                    <div class="filter-col">
                        <label>角色id</label>
                        <el-input v-model="params.roleId" placeholder="请输入角色id" clearable></el-input>
                    </div>
                </el-col>
                <div class="flex-end">
                    <el-button type="primary" @click="handleSearch"
                               v-if="allowAction.indexOf('view') != -1">查询</el-button>
                </div>
            </el-row>
        </div>
        <div class="data-box">
            <div class="modify-box">
                <el-button class="modify-button" type="primary" @click="handleAdd"
                           v-if="allowAction.indexOf('create') != -1">新建</el-button>
            </div>
            <div class="list-box">
                <el-table
                        :data="list"
                        stripe
                        style="width: 100%">
                    <el-table-column
                            label="角色ID"
                            prop="id"
                            align="center"
                            min-width="100">
                    </el-table-column>
                    <el-table-column
                            label="角色名"
                            prop="name"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            label="账号统计"
                            prop="userCount"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            label="创建时间"
                            prop="createTime"
                            align="center"
                            min-width="100">
                    </el-table-column>
                    <el-table-column
                            label="操作"
                            align="center"
                            fixed="right"
                            min-width="100"
                            v-if="optionStatus"
                    >
                        <template slot-scope="scope">
                            <div class="flex-middle flex-center">
                                <el-button
                                        class="btn-style mr20 b10"
                                        size="mini"
                                        type="text"
                                        @click="handleEdit(scope.row)"
                                        v-if="allowAction.indexOf('edit') != -1"
                                >编辑</el-button>
                                <el-button
                                        class="btn-style mr20 b10"
                                        size="mini"
                                        type="text"
                                        style="color: #F56C6C"
                                        @click="handleDelete(scope.row)"
                                        v-if="allowAction.indexOf('delete') != -1"
                                >删除</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>

                <!--分页-->
                <div class="t_m m10">
                    <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            :current-page.sync="params.pageNum"
                            :page-size="params.pageSize"
                            layout="total, prev, pager, next"
                            :total="pageTotal">
                    </el-pagination>
                </div>
            </div>
        </div>
        <AddRoleDialog v-on:fetchData="fetchData" ref="AddRoleDialog"></AddRoleDialog>
    </div>
</template>

<script>
    import AddRoleDialog from './components/AddRoleDialog.vue'
    import Utils from '@/assets/js/Utils'

    export default {
        name: 'RoleManage',
        components: {AddRoleDialog,},
        data() {
            return {
                allowAction: [],
                optionStatus: true,
                params: {
                    orderBy: null,
                    pageNum: 1,
                    pageSize: 5,
                    roleId: null,
                },
                list: [],
                pageTotal: null,

                roleList: [],
            }
        },
        mounted(){
            this.fetchData()
            this.allowAction = Utils.checkMenuOprate('system.role')
            for(let i = 0;i<this.allowAction.length; i++) {
                let item = this.allowAction[i]
                if(item != 'view' && item != 'create') {
                    this.optionStatus = true
                    return
                }
            }
            this.optionStatus = false
        },
        methods: {

            handleCurrentChange(val) {
                this.params.pageNum = val
                this.fetchData()
            },

            handleSearch() {
                this.fetchData()
            },

            fetchData() {
                let params = {
                    pageNum: this.params.pageNum,
                    pageSize: this.params.pageSize,
                    roleId: this.params.roleId?this.params.roleId:null
                }
                axios.get(Urls.URL.role_url,{params}).then(res => {
                    if(res.status == '200') {
                        this.list = res.data.data.rows
                        this.pageTotal = res.data.data.count
                    }
                }).catch(err => {
                    this.$alert(err.response.data.errorMessage || Utils.errorText)
                })
            },

            handleAdd() {
                this.$refs.AddRoleDialog && this.$refs.AddRoleDialog.setMaskVisible(true, {});
            },

            handleEdit(data) {
                this.$refs.AddRoleDialog && this.$refs.AddRoleDialog.setMaskVisible(true, data);
            },

            handleDelete(data) {
                this.$confirm(`角色“${data.name}”正在被删除，是否确定`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios.delete(Urls.URL.role_url+'/'+data.id).then(res => {
                        this.fetchData()
                    }).catch(err => {
                        this.$alert(err.response.data.errorMessage || Utils.errorText)
                    })
                }).catch(() => {
                    return
                });
            },
        }
    }
</script>

<style scoped lang="stylus">
    .body {
        width 100%
        height 100%
        padding-top 20px
    }

    .filter {
        padding 20px
        flex 1
        background-color white
        margin-bottom 20px
        .filter-col {
            display flex
            align-items center
            >label {
                width 15%
                min-width 80px
            }
            >.el-input {
                flex 1
                min-width 120px
            }
            >.el-select {
                flex 1
                min-width 120px
            }
        }
    }


    .data-box {
        flex 1
        background-color white
        .modify-box {
            flex 1
            height 80px
            padding 0 20px
            display flex
            align-items center
            .modify-button {
                width 100px
            }
        }
        .list-box {
            flex 1
            padding 0 25px
        }
    }

    .mb20 {
        margin-bottom 20px
    }

    .flex-end {
        flex 1
        display flex
        justify-content flex-end
        padding-right 20px
    }
</style>